// import Swiper from "./swiper";
// import "photoswipe";
import * as PhotoSwipe from 'photoswipe';
import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
// import PhotoSwipe from 'photoswipe';
// import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
// import "./v1/gallery";
// new Swiper([sliderV1, sliderV2, sliderGalleryV1, sliderGalleryV2, sliderPostsV1, sliderHeroV1]);
